import { CircularProgress, Box } from '@material-ui/core';
import React from 'react';

const FullLoader = () => {
	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			position="absolute"
			top="0"
			left="0"
			bottom="0"
			right="0"
		>
			<CircularProgress color="primary" />
		</Box>
	);
};

export default FullLoader;
